<template>
  <div class="coupon-warp" style="padding-bottom: 11.5px">
    <div class="horizonal-bar" v-if="couponList.length">
      <div class="flex space-between align-center">
        <div class="flex-left">
          <div class="bar-list flex">
            <div class="bar-item" v-for="(item, index) in couponList" :key="index">
              <span>
                满{{ item.threshold | intPrice
                }}{{ item.type === typeMap.discount ? `享${item.discounts}折` : `减${item.discounts / 100}` }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex-basic" @click="onReceive">
          <span>领取</span>
          <van-icon name="cap-arrow" />
        </div>
      </div>
    </div>
    <div>
      <van-modal-sheet
        round
        v-model="show"
        title="优惠"
        size="large"
        position="bottom"
        :close-on-click-overlay="false"
        @titleLeftClick="handleClose"
        left-icon
        left-icon-name="cap-close"
        right-text-color="#1E8DFF"
        class="coupon-modal"
      >
        <div class="coupon-list">
          <div class="list-warp">
            <coupon-item
              type="receive"
              v-for="(item, index) in couponList"
              showNewIcon
              :key="item.couponUserId"
              :item="item"
              @receiveCoupon="receiveCoupon"
            ></coupon-item>
          </div>
        </div>
      </van-modal-sheet>
    </div>
  </div>
</template>

<script>
import couponItem from './couponItem';
import { mapGetters, mapState } from 'vuex';
export default {
  components: { couponItem },
  filters: {
    intPrice(val) {
      if (!val) return val;
      return Number(val) / 100;
    }
  },
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    itemId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['mobileBinded'])
  },
  data() {
    return {
      typeMap: {
        reduce: 0,
        discount: 1
      },
      show: false,

      couponList: [],

      loading: true,
      finished: false,
      pageNo: 0,
      pageSize: 10,

      error: false,
      errorText: ''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onLoad() {},
    async getList() {
      this.loading = true;
      try {
        const res = await this.$fetch.getCouponListByItem({
          itemId: this.itemId
        });

        const { hasMore, couponItemInfoVOS: list } = res;

        this.couponList = list;
      } catch (error) {
        this.error = true;
        const { response, code } = error;
        this.errorText = error.message || this.errorText;
        if (!response && !code) {
          this.errorText = '请检查网络后再试';
          return;
        }
        if (response.status >= 500) {
          this.errorText = '系统开小差了，请稍后重试';
        }
      }
      this.loading = false;
    },
    onReceive() {
      this.show = true;
    },
    receiveCoupon(item) {
      if (!this.mobileBinded) {
        this.$router.push({ name: 'BindingMobilePage' });
        return;
      }

      this.$fetch.receiveCoupon({ couponId: item.id }).then((res) => {
        const { receiveStatus, message } = res;
        this.$toast(message);
        if (receiveStatus !== 5) {
          this.$set(item, 'receiveStatus', receiveStatus);
        }

        if (receiveStatus === 5) {
          this.$set(item, 'changeStatus', true);
        }

        // let result = data[0] || {};
      if (!this.mobileBinded) {
        this.$router.push({ name: 'BindingMobilePage' });
        return;
      }

        // if (!result.failureCode && result.getNum > 0) {
        //   this.$set(item, 'received', true);
        //   let discountAmountText =
        //     result.type === this.typeMap.reduce
        //       ? `${Number(result.discounts || 0) / 100}元优惠券`
        //       : `${result.discounts}折优惠券`;

        //   let toastText = `恭喜，已领取${result.getNum > 1 ? result.getNum : '一'}张${discountAmountText}`;
        //   this.$toast(toastText);
        // } else {
        //   this.$toast(result.reason || '该优惠券已被领完');
        //   this.$set(item, 'overLimit', true);
        // }
      });
    },
    handleClose() {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.coupon-modal {
  /deep/ .van-modal-sheet__header {
    .van-modal-sheet__left-area {
      color: #595959;
    }
  }
}
.coupon-warp {
  /deep/ .van-popup {
    overflow-y: hidden;
  }
}
.horizonal-bar {
  color: #ff4e47;
  font-size: 14px;
  .flex-left {
    width: calc(100% - 60px);
  }
  .bar-list {
    overflow: hidden;
    .bar-item {
      background-color: #ffeeeb;
      border-radius: 2px;
      padding: 2px 8px;
      margin-right: 8px;
      white-space: nowrap;
      line-height: normal;
      & > span {
        font-size: 14px;
      }
    }
  }
}
.icon-arrow {
  width: 12px;
  height: 12px;
}
.coupon-list {
  padding: 12px 16px;
  font-size: 14px;
  .top-bar {
    color: #262626;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    position: relative;
    padding-bottom: 24px;
    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 0;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .list-warp {
    .list-warp-content {
      position: relative;
      .hasget-icon {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 60px;
        width: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .list-item {
      height: 92px;
      background: url('../../../assets/imgs/coupon/coupon-bg.png') center no-repeat;
      background-size: 100% auto;
      margin-bottom: 12px;
      overflow: hidden;
      .list-item-money {
        text-align: center;
        color: #ff4e47;
        font-size: 32px;
        flex: 1;
        font-weight: 500;
        .yuan {
          font-size: 20px;
        }
      }
      .list-item-info {
        flex: 1.5;
        padding: 0 0 0 16px;
        .date,
        .apply-goods {
          color: #595959;
          font-size: 10px;
        }
        .full-reduction {
          color: #ff4e47;
          font-weight: 500;
        }
        .date {
          margin: 8px 0 4px 0;
        }
      }
      .receive-btn {
        color: #ff4e47;
        font-weight: 500;
        width: 72px;
      }
    }
  }
}
.flex {
  display: flex;
  width: 100%;
  &.space-between {
    justify-content: space-between;
  }
  &.align-center {
    align-items: center;
  }
  .flex-basic {
    font-size: 12px;
    width: 60px;
    text-align: right;
  }
}
</style>
